module.exports = __webpack_public_path__ + "static/TheMetSans-LightItalic-e6858368a8790ac4a40346c01927f851.woff";